import Vue from "vue";
import { includes, filter } from "lodash";
import ApiService from "@/api";
import localforage from "localforage";
export default class MessagingService {
    constructor() {
        this.messaging = Vue.prototype.$messaging;
        // Token refresh event
        this.messaging.onTokenRefresh(function() {
            console.log("Token refreshed.");
            this.messaging
                .getToken()
                .then(function(refreshedToken) {
                    this.setTokenSentToServerFlg(false);
                    this.sendTokenToServer(refreshedToken);
                })
                .catch(function(err) {
                    console.log("Unable to retrieve refreshed token ", err);
                });
        });

        // Receiving message event
        const _this = this;
        this.messaging.onMessage(function(payload) {
            // console.log("Message received", payload);
            localforage.getItem("areInCampings").then(areInCampingsObject => {
                const { data } = payload;
                const areInCampings = areInCampingsObject.map(item =>
                    Number(item.id)
                );
                const campings = data.campings ? JSON.parse(data.campings) : [];
                const swRegistration = _this.messaging.swRegistration;
                const notificationTitle = data.title.split('\\').join(''); //eslint-disable-line
                let matchCampings = filter(campings, camping =>
                    includes(areInCampings, Number(camping.id))
                );
                console.log("message background", data);
                if (matchCampings.length === 0 && !data.is_to_all) {
                    return;
                }
                const notificationOptions = {
                    body: data.body.split('\\').join(''), //eslint-disable-line
                    icon: "./img/noti.png",
                    data: { url: data.links }
                };
                return swRegistration.showNotification(
                    notificationTitle,
                    notificationOptions
                );
            });
        });
    }

    /* Request user's permission */
    async requestPermissionAsync() {
        if (window.localStorage.getItem("isRequestPermission") !== "true") {
            try {
                await this.messaging.requestPermission();
                window.localStorage.setItem("isRequestPermission", "true");
                console.log("Notification permission granted.");
            } catch (err) {
                console.log("Unable to get permission to notify.", err);
            }
        }

        // this.messaging.requestPermission().then(function () {
        //     console.log('Notification permission granted.');
        //     // TODO(developer): Retrieve an Instance ID token for use with FCM.
        // }).catch(function (err) {
        //     console.log('Unable to get permission to notify.', err);
        // });
    }

    /* Get messaging token */
    async getTokenAsync() {
        try {
            let currentToken = await this.messaging.getToken();
            if (currentToken) {
                await this.sendTokenToServerAsync(currentToken);
                return currentToken;
            } else {
                // Show permission request.
                console.log(
                    "No Instance ID token available. Request permission to generate one."
                );
                // Show permission UI.
                this.setTokenSentToServerFlg(false);
                return false;
            }
        } catch (err) {
            console.log("An error occurred while retrieving token. ", err);
            this.setTokenSentToServerFlg(false);
            return false;
        }
    }

    /* Delete Instance ID token */
    async deleteTokenAsync() {
        try {
            let currentToken = await this.messaging.getToken();
            await this.messaging.deleteToken(currentToken);
            this.setTokenSentToServerFlg(false);
            console.log("Token deleted: " + currentToken);
        } catch (err) {
            console.log("Unable to delete token. ", err);
        }
    }

    // Send the Instance ID token your application server, so that it can:
    // - send messages back to this app
    // - subscribe/unsubscribe the token from topics
    async sendTokenToServerAsync(currentToken) {
        console.log("currentToken", currentToken);
        try {
            if (!this.isTokenSentToServer(currentToken)) {
                console.log("Sending token to server...");
                this.saveDeviceToken(currentToken);
                // TODO: Send the current token to your server.
                this.setTokenSentToServerFlg(currentToken);
            } else {
                console.log(
                    "Token already sent to server so won't send it again unless it changes"
                );
            }
        } catch (err) {
            console.log("Unable to send token to server", err);
        }
    }

    isTokenSentToServer(currentToken) {
        return window.localStorage.getItem("sentToServer") === currentToken;
    }

    setTokenSentToServerFlg(sent) {
        window.localStorage.setItem("sentToServer", sent ? sent : "0");
    }
    saveDeviceToken(token) {
        localforage.getItem("lang").then(lang => {
            return new Promise(resolve => {
                let url = `update-token/?token=${token}`;
                if (lang === "en") {
                    url = `en/update-token/?token=${token}`;
                }
                ApiService.get(url)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch(() => {});
            });
        });
    }
}
